<template>
  <v-list-item v-if="machine" @click="!invertPreview ? $emit('select') : togglePreview()" dense :disabled="disabled"
    :class="[(isSelected || (hasBeenSelected && showHasBeenSelected)) ? 'pl-3 ' + (isSelected ? 'selectedIndicator' : (hasBeenSelected && showHasBeenSelected ? 'hasBeenSelectedIndicator' : '')) : 'pl-5', right ? 'right' : '', 'pr-0']"
    :style="machine.IsActive ? '' : 'background-color: rgba(0, 0, 0, 0.07); !important;'">
    <div v-if="showCheckbox" class="ml-n5" :style="isSelected ? '' : 'background-color: rgba(0, 0, 0, 0.02);'"
      style="align-self: stretch;">
      <v-list-item-action class="ma-0 d-flex align-center action inset"
        style="height: 100%; pointer-events: all !important;">
        <v-btn tile class="" style="height: 100%; min-width: 56px; background-color: transparent;"
          @click.stop="$emit('checked', !hasBeenSelected)">
          <v-simple-checkbox :value="hasBeenSelected" color="primary" @click.stop="$emit('checked', !hasBeenSelected)">
          </v-simple-checkbox>
        </v-btn>
      </v-list-item-action>
    </div>
    <v-list-item-icon class="mr-5 my-auto d-none d-sm-block" style="height: auto;">
      <MachineModelImage :size="40"
        :relativePath="machine && machine.MachineModel && machine.MachineModel.ModelImage" />
    </v-list-item-icon>
    <v-list-item-content class="py-2">
      <v-list-item-title :class="machine.IsActive ? 'useThemeTextColor' : 'deactivated'"
        style="font-size: 12.8px !important;">
        {{ machineText }}
      </v-list-item-title>
      <v-list-item-subtitle :class="machine.IsActive ? 'primary--text' : 'deactivated'"
        style="font-size: 12.8px !important;">
        {{ machineIdentifierText(machine) }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-content class="py-2 d-none d-lg-block" v-if="!compact">
      <v-list-item-title :class="machine.IsActive ? 'useThemeTextColor' : 'deactivated'"
        style="font-size: 12.8px !important;">
        {{ machineModelText }}
      </v-list-item-title>
    </v-list-item-content>    
    <v-list-item-content class="py-2 d-none d-lg-block" v-if="!compact">
      <v-list-item-title :class="machine.IsActive ? 'useThemeTextColor' : 'deactivated'"
        style="font-size: 12.8px !important;">
        {{ supplierText }}
      </v-list-item-title>
    </v-list-item-content>
    <v-list-item-action v-if="showServiceAgreement" class="ma-0 d-none d-sm-flex" style="pointer-events: all !important;">
      <MachineServiceAgreementIcon :machine="machine" @Update="v => $emit('Update', v.Machine)" class="position-static">
      </MachineServiceAgreementIcon>
    </v-list-item-action>
    <v-scroll-x-transition v-if="inspectable">
      <div :style="isSelected ? '' : 'background-color: rgba(0, 0, 0, 0.02);'" style="align-self: stretch;">
        <v-list-item-action class="ma-0 d-flex align-center action inset"
          style="height: 100%; pointer-events: all !important;">
          <v-btn tile style="height: 100%; background-color: transparent;"
            @click.stop="!invertPreview ? togglePreview() : $emit('select')">
            <v-icon :color="!invertPreview && isSelected ? 'primary' : '#676767'">
              {{ !invertPreview ? (isSelected ? ' mdi-arrow-collapse-left' : 'mdi-view-split-vertical') : 'mdi-pencil'
              }}
            </v-icon>
          </v-btn>
        </v-list-item-action>
      </div>
    </v-scroll-x-transition>
  </v-list-item>
</template>


<script>
import MachineMixin from "@/helpers/Mixins/MachineMixin.js";
import MachineModelImage from "@/views/job/newjob/cards/machines/MachineModelImage.vue";

export default {
  name: "MachineListItem",
  props:
  {
    compact: {
      type: Boolean,
      default: true
    },
    machine: Object,
    preselected: Array,
    right: Boolean,
    isSelected: Boolean,
    inspectable: Boolean,
    disabled: Boolean,
    showCheckbox: Boolean,
    showServiceAgreement: {
      type: Boolean,
      default: true,
    },
    invertPreview: Boolean,
    showHasBeenSelected: {
      type: Boolean,
      default: true,
    }
  },
  emits: ["select", 'openPreview', 'closePreview'],
  components: {
    MachineServiceAgreementIcon: () => import('@/views/job/newjob/cards/machines/MachineServiceAgreementIcon.vue'),
    MachineModelImage,
  },
  mixins: [MachineMixin],

  data: () => ({
  }),

  mounted() {

  },

  methods: {
    togglePreview() {
      this.isSelected ? this.$emit('closePreview') : this.$emit('openPreview', this.machine);
    },
  },

  computed: {
    machineText() {
      return this.machine?.DisplayName ?? ""
    },
    machineModelText() {
      return this.machine?.MachineModel?.Name ?? ""
    },
    supplierText() {
      return this.machine?.MachineModel?.Supplier?.Name ?? ""
    },
    hasBeenSelected() {
      if (this.preselected?.includes(this.machine.Id)) {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {
  },
};
</script>

<style lang="scss" scoped>
.hasBeenSelectedIndicator {
  background-color: rgb(248, 255, 248) !important;
  z-index: 2;
  border-left: 8px solid var(--v-success-base);
  border-right: none;
}

.selectedIndicator {
  background-color: rgb(249, 249, 249) !important;
  z-index: 2;
  border: 1px solid #427aaf;
  border-left: 8px solid #427aaf;
  border-right: none;
}

.selectedIndicator.right {
  border-left: none !important;
  border-right: 8px solid #427aaf !important;
  position: relative;
}

.mdi-checkbox-blank-outline {
  //just to make the unchecked checkboxes a bit less striking
  color: rgb(141, 141, 141) !important;
}

.deactivated:not(:hover) {
  color: var(--v-disabled-darken2) !important;
  text-decoration: line-through !important;
}
.position-static {
  position: absolute;
  transform: translate(-50%, -50%)
}
/* TODO: fix right element flow-over to previewpane
.selectedIndicator.right::after{
  content: "";
  position: absolute;
  background-color: red;
  width: 2px;
  height: 100%;
  left: -1px;
  z-index: 2;
}*/
</style>